<div class="access-denied">
  <h1>Access Denied</h1>
  <p>You do not have permission to view this page.</p>
  <button routerLink="/" mat-raised-button color="primary">Go Home</button>
</div>
